
<div class="container">


        <h2 class="content-heading">
            <!-- <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
              <i class="fa fa-plus mr-5"></i>Add Lectionary Track
            </button> -->
              Lectionary Track
        </h2>


      <div class="block">

        <!--
        <div class="block-header block-header-default">
            <h3 class="block-title"></h3>
        </div>
      -->

        <div class="block-content">
            <div class="table-responsive ">
                <table class="table table-striped table-vcenter table-sm">
                    <thead>
                        <tr>
                          <th>Name</th>
                          <th>Description</th>
                          <th style="text-align: right">Display Order</th> 
                        </tr>
                    </thead>
                    <tbody>


                      <tr *ngFor="let obj of entities">
                        <td class="font-w600">{{obj.Localized[0].Name}}</td>
                        <td class="font-w600">{{obj.Localized[0].Description}}</td>
                        <td class="font-w600" style="text-align: right">{{obj.DisplayOrder}}</td>
                     
                      </tr>

                    </tbody>
                </table>

                <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

              </div>


        </div>

      </div>

      </div>

